import { z } from "zod/index";

export const ROUTE_UNIT_KM = "km";
export const ROUTE_UNIT_MILES = "miles";

export const TRANSPORT_TYPE_WALKING = "Walking";
export const TRANSPORT_TYPE_BICYCLE = "Bicycle";
export const TRANSPORT_TYPE_CAR = "Car";
export const TRANSPORT_TYPE_TRANSIT = "Transit";

export const ATTRACTION_TYPE_NATURE = "Nature";
export const ATTRACTION_TYPE_ARCHITECTURE = "Architecture";
export const ATTRACTION_TYPE_RELIGION = "Religion";

export const GOOGLEMAPS_API_TRAVEL_MODE_WALKING = "walking";
export const GOOGLEMAPS_API_TRAVEL_MODE_BICYCLE = "bicycling";
export const GOOGLEMAPS_API_TRAVEL_MODE_CAR = "driving";
export const GOOGLEMAPS_API_TRAVEL_MODE_TRANSIT = "transit";

export const M_URI_PATH = "/m";
export const M_URI_FULL_ROOT_PATH = M_URI_PATH + "/";
export const LOGIN_URI_PATH = "/m/login";
export const LOGOUT_URI_PATH = "/m/logout";
export const REGISTER_URI_PATH = "/m/register";
export const FORGOT_PASSWORD_URI_PATH = "/m/forgot-password";
export const ACCOUNT_SETTINGS_URI_PATH = "/m/account/settings";

export const ROUTES_URI_PATH = "/m/routes";

export interface RoutePlaceViewModel {
  name: string;
  id: string;
  latitude: number;
  longitude: number;
  transportType: string;
  transportTypeInSelectedLanguage: string;
  distanceFromPreviousPlace: string;
  distanceFromPreviousPlaceInSelectedUnit: number;
  durationFromPreviousPlace: string;
  durationFromPreviousPlaceInMinutes: number;
  arrivalTime: string;
  arrivalTimeTextWithLabel: string;
  activityType: string;
  activityTypeInSelectedLanguage: string;
  activityDuration: string;
  activityDurationInMinutes: number;
  departureTime: string;
  departureTimeTextWithLabel: string;
  descriptionOfAttraction: string;
  whatToDoHereLongText: string;
  typeOfAttractionInSelectedLanguage: string;
  website: string;
}

export interface RouteRequestModel {
  location: string
  coordinates: [ number, number ];
  transportTypes: string[];
  attractionTypes: string[];
  radius: number;
  duration: number;
}

export interface RouteViewModel {
  id: string;
  name: string;
  totalDuration: string;
  totalDistance: string;
  places: RoutePlaceViewModel[];
  request: RouteRequestModel;
  createdById: string;
}
